import type { JSX } from 'react'
import type { IInputProps } from '../Input'

import { ButtonIconSizes } from 'atoms/Button'
import { TextBoxTypes } from 'atoms/TextBox'
import { Input } from '../Input'
import {
  InputActionButtonIndent,
  InputBorders,
  InputFontColors,
  InputFonts,
  InputNames,
  InputPaddings,
} from '../Input.h'

export interface ILoginPasswordInputProps extends IInputProps {}

export const LoginPasswordInput = ({
  name = InputNames.Password,
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  label = '',
  labelFont = TextBoxTypes.Caption4,
  iconSize = ButtonIconSizes.small,
  font = InputFonts.Body4,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  required = true,
  secured = true,
  paddings = InputPaddings.SIZE_20,
  borders = InputBorders.BORDER_10,
  inputWrapperHeight = '40px',
  actionButtonIndent = InputActionButtonIndent.INDENT_60,
  ...rest
}: ILoginPasswordInputProps): JSX.Element => (
  <Input
    name={name}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    label={label}
    font={font}
    colorDefault={colorDefault}
    required={required}
    secured={secured}
    paddings={paddings}
    borders={borders}
    iconSize={iconSize}
    labelFont={labelFont}
    inputWrapperHeight={inputWrapperHeight}
    actionButtonIndent={actionButtonIndent}
    {...rest}
  />
)
